import React from 'react';

export const SportIcon = ({ id, name }) => (
  <i
    className={`icon sportIcon sportIcon-${id && `${id}`.toLowerCase()}`}
    title={name}
  />
);
